module.exports = __webpack_public_path__ + "img/left-1.7e6145aa.jpg";